import { useEffect, useRef } from 'react'

import { useTranslation } from 'react-i18next'

import { Alert } from '@hivewatch/dark'

import {
  DISPATCH_NO_AVAILABLE_GUARDS_ALERT_SHOWN,
  trackEvent,
} from '@/utils/analytics'

import { MixpanelDataIProps } from '../../../../shared/types/types'

type ColorScheme = 'dark' | 'light'

interface NoAvailableGuardsAlertIProps {
  hasGuards: boolean
  colorScheme?: ColorScheme
  mixpanelData?: MixpanelDataIProps
}

/**
 * Warns that there is nobody to dispatch.
 */
export const NoAvailableGuardsAlert = ({
  hasGuards,
  colorScheme = 'dark',
  mixpanelData,
}: NoAvailableGuardsAlertIProps) => {
  const { t } = useTranslation()
  // Guards are polled, so hasGuards can flip and re-run the effect;
  // the ref caps the event at once per mount.
  const hasTrackedShownRef = useRef(false)

  useEffect(() => {
    if (!hasGuards && !hasTrackedShownRef.current) {
      hasTrackedShownRef.current = true
      trackEvent(DISPATCH_NO_AVAILABLE_GUARDS_ALERT_SHOWN, mixpanelData)
    }
  }, [hasGuards, mixpanelData])

  if (hasGuards) {
    return null
  }

  return (
    <Alert
      colorScheme={colorScheme}
      title={t('incidents:dispatch_no_available_guards')}
      variant='warning'
    />
  )
}
